"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelRefundBySupplierApi = cancelRefundBySupplierApi;
exports.confirmGoodsApi = confirmGoodsApi;
exports.getLogisticsBySupplierInfoApi = getLogisticsBySupplierInfoApi;
exports.getLogisticsInfoApi = getLogisticsInfoApi;
exports.getLogisticsInfoByNoApi = getLogisticsInfoByNoApi;
exports.merchantOrderExcelApi = merchantOrderExcelApi;
exports.orderDetailApi = orderDetailApi;
exports.orderDetailApiByRetailer = orderDetailApiByRetailer;
exports.orderDetailByRefundApi = orderDetailByRefundApi;
exports.orderExcelApi = orderExcelApi;
exports.orderInvoiceListApi = orderInvoiceListApi;
exports.orderListApi = orderListApi;
exports.orderMarkApi = orderMarkApi;
exports.orderRefundApi = orderRefundApi;
exports.orderStatisticsApi = orderStatisticsApi;
exports.orderStatusNumApi = orderStatusNumApi;
exports.refundDetailApi = refundDetailApi;
exports.refundInitMallApi = refundInitMallApi;
exports.refundListApi = refundListApi;
exports.refundMarkApi = refundMarkApi;
exports.refundOrderDetailApi = refundOrderDetailApi;
exports.refundStatusNumApi = refundStatusNumApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 订单 列表
 * @param prams
 */
function orderListApi(params) {
  return (0, _request.default)({
    url: '/admin/retailer/order/list',
    method: 'get',
    params: params
  });
}

/**
 * 订单 列表 获取各状态数量
 * @param params
 */
function orderStatusNumApi(params) {
  return (0, _request.default)({
    url: '/admin/retailer/order/status/num',
    method: 'get',
    params: params
  });
}
function confirmGoodsApi(data) {
  return (0, _request.default)({
    url: "/admin/retailer/order/confirm/goods",
    method: 'post',
    data: data
  });
}

/**
 * 订单 详情
 * @param prams
 */
function orderDetailApi(params) {
  return (0, _request.default)({
    url: '/admin/retailer/order/info',
    method: 'get',
    params: params
  });
}
/**
 * 订单 详情
 * @param prams
 */
function orderDetailByRefundApi(params) {
  return (0, _request.default)({
    url: '/admin/retailer/order/refund/infoByRefund',
    method: 'get',
    params: params
  });
}
function orderDetailApiByRetailer(params) {
  return (0, _request.default)({
    url: '/admin/retailer/order/retailer/info',
    method: 'get',
    params: params
  });
}

/**
 * 订单 备注
 * @param prams
 */
function orderMarkApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/mark',
    method: 'post',
    params: params
  });
}

/**
 * 订单 立即退款
 * @param prams
 */
function orderRefundApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/refund',
    method: 'get',
    params: params
  });
}

/**
 * 订单 统计 头部数据
 */
function orderStatisticsApi() {
  return (0, _request.default)({
    url: "/admin/store/order/statistics",
    method: 'get'
  });
}

/**
 *平台端订单物流详情
 */
function getLogisticsInfoApi(invoiceId) {
  return (0, _request.default)({
    url: "/admin/platform/order/get/".concat(invoiceId, "/logistics/info"),
    method: 'get'
  });
}
function getLogisticsInfoByNoApi(logisticsNo) {
  return (0, _request.default)({
    url: "/admin/merchant/order/logistics/info/" + logisticsNo,
    method: 'get'
  });
}

/**
 *平台端订单物流详情 查询渠道物流
 */
function getLogisticsBySupplierInfoApi(mainDistributionOrderId) {
  return (0, _request.default)({
    url: "/admin/platform/order/get/logisticsBySupplier/info/".concat(mainDistributionOrderId),
    method: 'get'
  });
}

/**
 *退款列表
 */
function refundListApi(params) {
  return (0, _request.default)({
    url: "/admin/retailer/order/refund/list",
    method: 'get',
    params: params
  });
}

/**
 *退款详情
 */
function refundDetailApi(refundOrderNo) {
  return (0, _request.default)({
    url: "/admin/platform/refund/order/detail/".concat(refundOrderNo),
    method: 'get'
  });
}

/**
 *平台备注退款订单
 */
function refundMarkApi(data) {
  return (0, _request.default)({
    url: "/admin/retailer/order/refund/mark",
    method: 'post',
    data: data
  });
}

/**
 *平台取消渠道退款订单
 */
function cancelRefundBySupplierApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/order/refund/cancel",
    method: 'post',
    data: data
  });
}
function refundInitMallApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/order/retailer/refund/init",
    method: 'post',
    data: data
  });
}

/**
 *获取退款订单各状态数量
 */
function refundStatusNumApi(params) {
  return (0, _request.default)({
    url: "/admin/retailer/order/refund/status/num",
    method: 'GET',
    params: params
  });
}

/**
 * 获取订单发货单列表
 * @param orderNo 订单号
 */
function orderInvoiceListApi(orderNo) {
  return (0, _request.default)({
    url: "/admin/platform/order/".concat(orderNo, "/invoice/list"),
    method: 'get'
  });
}

/**
 * 商户端退款订单详情
 * @param refundOrderNo 订单号
 */
function refundOrderDetailApi(refundOrderNo) {
  return (0, _request.default)({
    url: "/admin/retailer/order/refund/detail/".concat(refundOrderNo),
    method: 'get'
  });
}

/**
 * 平台端退款订单详情
 * @param params 对象
 */
function orderExcelApi(params) {
  return (0, _request.default)({
    url: "/admin/platform/export/order/excel",
    method: 'get',
    params: params
  });
}

/**
 * 商户端订单详情导出
 * @param params 对象
 */
function merchantOrderExcelApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/export/distributor/order/excel",
    method: 'get',
    params: params
  });
}